export default __webpack_public_path__ + "static/media/Sign_in_squre_light.c15e5dda.svg";